/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import { connectRequests } from '../../../../../higherOrderComponents/requests';


export default connectRequests((state, props) => {
  const id = props.subscriber.id;
  const token = state.token;
  return {
    postProductSubscription: {
      method: 'POST',
      url: `/subscribe?token=${token}`
    },
    postSubscription: {
      method: 'POST',
      url: `/subscribers/subscriptions/${id}?token=${token}`
    },
  };
});
